import { animate, state, style, transition, trigger } from "@angular/animations"

export const rotateAnimation = trigger('rotateAnimation', [
    state('down', 
        style({
            transform: 'rotate(270deg)'
        })
    ),
    state('up', 
        style({
            transform: 'rotate(360deg)'
        })
    ),
    transition('down <=> up', animate('300ms ease-in-out')),
]);